export enum AdminPermission {
  add = 'admin.add',
  edit = 'admin.edit',
  list = 'admin.list',
  view = 'admin.view',
  delete = 'admin.delete',
}

export enum RolePermission {
  add = 'role.add',
  edit = 'role.edit',
  list = 'role.list',
  view = 'role.view',
  delete = 'role.delete',
}

export enum LocationPermission {
  add = 'location.add',
  edit = 'location.edit',
  list = 'location.list',
  view = 'location.view',
  delete = 'location.delete',
  reorder = 'location.reorder',
  addon = 'location.addon',
}

export enum SpacePermission {
  add = 'space.add',
  edit = 'space.edit',
  list = 'space.list',
  delete = 'space.delete',
  pricing = 'space.pricing',
  gallery = 'space.gallery',
  reorder = 'space.reorder',
  tickets = 'space.tickets',
}

export enum EventPermission {
  add = 'event.add',
  edit = 'event.edit',
  list = 'event.list',
  view = 'event.view',
  delete = 'event.delete',
}

export enum ClassPermission {
  add = 'class.add',
  edit = 'class.edit',
  list = 'class.list',
  view = 'class.view',
  delete = 'class.delete',
  gallery = 'class.gallery',
  logs = 'class.logs',
  tickets = 'class.tickets',
  cancelEnrollment = 'class.cancelEnrollment',
  completeEnrollment = 'class.completeEnrollment',
  addEnrollmentPayment = 'class.addEnrollmentPayment',
  confirmCompletedEnrollment = 'class.confirmCompletedEnrollment',
}

export enum TournamentPermission {
  add = 'tournament.add',
  edit = 'tournament.edit',
  list = 'tournament.list',
  view = 'tournament.view',
  delete = 'tournament.delete',
}

export enum TournamentDivisionPermission {
  add = 'tournament_division.add',
  edit = 'tournament_division.edit',
  list = 'tournament_division.list',
  view = 'tournament_division.view',
  delete = 'tournament_division.delete',
  updateBracketImage = 'tournament_division.updateBracketImage',
  reorder = 'tournament_division.reorder',
}

export enum TournamentTeamPermission {
  add = 'tournament_team.add',
  edit = 'tournament_team.edit',
  list = 'tournament_team.list',
  view = 'tournament_team.view',
  delete = 'tournament_team.delete',
  approve = 'tournament_team.approve',
  reject = 'tournament_team.reject',
}

export enum TournamentGroupPermission {
  add = 'tournament_group.add',
  edit = 'tournament_group.edit',
  list = 'tournament_group.list',
  view = 'tournament_group.view',
  delete = 'tournament_group.delete',
  updateStandings = 'tournament_group.updateStandings',
  reorderTeams = 'tournament_group.reorderTeams',
}

export enum TournamentMatchPermission {
  add = 'tournament_match.add',
  edit = 'tournament_match.edit',
  list = 'tournament_match.list',
  view = 'tournament_match.view',
  enterResult = 'tournament_match.enterResult',
  delete = 'tournament_match.delete',
}

export enum TournamentKnockoutStagePermission {
  add = 'tournament_knockout_stage.add',
  edit = 'tournament_knockout_stage.edit',
  list = 'tournament_knockout_stage.list',
  view = 'tournament_knockout_stage.view',
  delete = 'tournament_knockout_stage.delete',
  reorder = 'tournament_knockout_stage.reorder',
}

export enum DashboardPermission {
  view = 'dashboard.view',
  allDaysAccess = 'dashboard.allDaysAccess',
}

export enum BookingPermission {
  add = 'booking.add',
  import = 'booking.import',
  edit = 'booking.edit',
  list = 'booking.list',
  view = 'booking.view',
  calender = 'booking.calender',
  allDaysAccess = 'booking.allDaysAccess',
  cancel = 'booking.cancel',
  delete = 'booking.delete',
  complete = 'booking.complete',
  markAsMissed = 'booking.markAsMissed',
  markAsContacted = 'booking.markAsContacted',
  logs = 'booking.logs',
  statistics = 'booking.statistics',
  export = 'booking.export',
  confirmCompleted = 'booking.confirmCompleted',
}

export enum TransactionPermission {
  add = 'transaction.add',
  list = 'transaction.list',
  allDaysAccess = 'transaction.allDaysAccess',
  export = 'transaction.export',
  delete = 'transaction.delete',
}

export enum UserPermission {
  add = 'user.add',
  list = 'user.list',
  view = 'user.view',
  edit = 'user.edit',
  toggle = 'user.toggle',
  export = 'user.export',
}

export enum BannerPermission {
  add = 'banner.add',
  list = 'banner.list',
  view = 'banner.view',
  edit = 'banner.edit',
  delete = 'banner.delete',
}

export enum PackagePermission {
  add = 'package.add',
  list = 'package.list',
  view = 'package.view',
  edit = 'package.edit',
  delete = 'package.delete',
}

export enum TenantPermission {
  add = 'tenant.add',
  list = 'tenant.list',
  view = 'tenant.view',
  assignTenantToPackage = 'tenant.assignTenantToPackage',
  edit = 'tenant.edit',
  delete = 'tenant.delete',
}

export enum ApiSettingPermission {
  view = 'api_setting.view',
  edit = 'api_setting.edit',
}

export enum AuditTrailPermission {
  list = 'audit_trail.list',
}

export enum CampaignPermission {
  add = 'campaign.add',
  list = 'campaign.list',
  delete = 'campaign.delete',
}

export enum TenantGalleryPermission {
  list = 'tenant_gallery.list',
  add = 'tenant_gallery.add',
  edit = 'tenant_gallery.edit',
  delete = 'tenant_gallery.delete',
}

export enum TenantContactPermission {
  list = 'tenant_contact.list',
  add = 'tenant_contact.add',
  edit = 'tenant_contact.edit',
  delete = 'tenant_contact.delete',
}

export enum TicketPermission {
  add = 'ticket.add',
  edit = 'ticket.edit',
  list = 'ticket.list',
  delete = 'ticket.delete',
  reorder = 'ticket.reorder',
}

export enum SmsCampaignPermission {
  add = 'sms_campaign.add',
  list = 'sms_campaign.list',
  delete = 'sms_campaign.delete',
  view = 'sms_campaign.view',
}

export enum PromoCampaignPermission {
  add = 'promo_campaign.add',
  edit = 'promo_campaign.edit',
  list = 'promo_campaign.list',
  delete = 'promo_campaign.delete',
  view = 'promo_campaign.view',
  toggleStatus = 'promo_campaign.toggleStatus',
  logs = 'promo_campaign.logs',
}

export enum DynamicListPermission {
  add = 'dynamic_list.add',
  edit = 'dynamic_list.edit',
  list = 'dynamic_list.list',
  delete = 'dynamic_list.delete',
}

export enum PromoCodePermission {
  toggleStatus = 'promo_code.toggleStatus',
  logs = 'promo_code.logs',
}

export enum TripPermission {
  add = 'trip.add',
  edit = 'trip.edit',
  list = 'trip.list',
  view = 'trip.view',
  delete = 'trip.delete',
  tickets = 'trip.tickets',
  customFields = 'trip.customFields',
}

export enum TripDestinationPermission {
  add = 'trip_destination.add',
  edit = 'trip_destination.edit',
  list = 'trip_destination.list',
  view = 'trip_destination.view',
  delete = 'trip_destination.delete',
}

export enum AddonPermission {
  add = 'addon.add',
  edit = 'addon.edit',
  list = 'addon.list',
  view = 'addon.view',
  toggleStatus = 'addon.toggleStatus',
  reorder = 'addon.reorder',
  configure = 'addon.configure',
}

export enum CustomerGroupPermission {
  add = 'customer_group.add',
  edit = 'customer_group.edit',
  list = 'customer_group.list',
  view = 'customer_group.view',
  delete = 'customer_group.delete',
  editMembers = 'customer_group.editMembers',
  import = 'customer_group.import',
}

export type PermissionType =
  | AdminPermission
  | RolePermission
  | LocationPermission
  | SpacePermission
  | DashboardPermission
  | BookingPermission
  | TransactionPermission
  | UserPermission
  | BannerPermission
  | PackagePermission
  | TenantPermission
  | EventPermission
  | ClassPermission
  | ApiSettingPermission
  | CampaignPermission
  | AuditTrailPermission
  | TenantGalleryPermission
  | TenantContactPermission
  | TicketPermission
  | SmsCampaignPermission
  | TournamentPermission
  | TournamentDivisionPermission
  | TournamentTeamPermission
  | TournamentGroupPermission
  | TournamentMatchPermission
  | TournamentKnockoutStagePermission
  | PromoCampaignPermission
  | PromoCodePermission
  | DynamicListPermission
  | TripPermission
  | TripDestinationPermission
  | AddonPermission
  | CustomerGroupPermission;
